import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaChevronDown, FaChevronUp, FaQuestionCircle, FaEnvelope, FaPhone, FaTimes } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';

const FAQ = ({ titre }) => {
    useAuth();
    const user_id = localStorage.getItem('user_id');
    const [searchTerm, setSearchTerm] = useState('');
    const [openQuestion, setOpenQuestion] = useState(null);

const faqData = [
{
    id: 1,
    question: "Quelle est la différence entre Simulation, Examen et Essai ?",
    answer: `
        <p><b>Simulation :</b> Entraînement libre sans contrainte de temps.</p>
        <p><b>Examen :</b> Session officielle avec une durée définie (1h, 3h ou 4h) et des pauses programmées.</p>
        <p><b>Essai :</b> Ce sont des sortes de simulations réalisées lors des coachings.</p>
    `
},
{
    id: 2,
    question: "Comment accéder à l'historique de mes activités ?",
    answer: `
        <p>Rendez-vous dans l'onglet <b>'Simulateur'</b> depuis le menu principal. Vous verrez la liste unifiée de toutes vos simulations et examens, triés du plus récent au plus ancien.</p>
    `
},
{
    id: 3,
    question: "Comment créer une nouvelle simulation ?",
    answer: `
        <p>Cliquez sur <b>'Nouvelle simulation'</b>, sélectionnez vos critères (domaine, niveau, langue, nombre de QCM), puis cliquez sur <b>'Enregistrer'</b>.</p>
    `
},
{
    id: 4,
    question: "Comment reprendre une simulation ?",
    answer: `
        <p>Dans l'historique, repérez la simulation, cliquez sur les trois points (⋮) puis <b>'Démarrer'</b> ou <b>'Recommencer'</b>.</p>
    `
},
{
    id: 5,
    question: "Où voir mes résultats de simulation ?",
    answer: `
        <p>Une fois la simulation terminée, cliquez sur les trois points (⋮) puis <b>'Résultats'</b>. Le pourcentage de bonnes réponses s'affiche dans l'historique.</p>
    `
},
{
    id: 6,
    question: "Comment réserver un examen blanc ?",
    answer: `
        <p>Cliquez sur <b>'Réserver Examen'</b>, choisissez date, heure, type (PMP/CAPM), langue et durée, puis validez.</p>
    `
},
{
    id: 7,
    question: "Que faire si je souhaite modifier ma réservation ?",
    answer: `
        <p>Seuls les examens en <b>'En cours de validation'</b> peuvent être modifiés. Cliquez sur les trois points (⋮) puis <b>'Modifier'</b>.</p>
    `
},
{
    id: 8,
    question: "Puis-je continuer un examen interrompu ?",
    answer: `
        <p>Oui tant que vous êtes connecté sur la plateforme. Retrouvez l'examen dans l'historique et cliquez sur <b>'Continuer'</b>. Votre progression est automatiquement sauvegardée.</p>
    `
},
{
    id: 9,
    question: "Comment créer un essai ?",
    answer: `
        <p>Cliquez sur <b>'Nouvel essai'</b>, saisissez le code fourni par votre formateur, choisissez la langue, puis validez.</p>
    `
},
{
    id: 10,
    question: "Puis-je recommencer un essai terminé ?",
    answer: `
        <p>Oui. Cliquez sur les trois points (⋮) puis <b>'Recommencer'</b> pour réinitialiser vos réponses.</p>
    `
},
{
    id: 11,
    question: "Comment ajouter une question en favori ?",
    answer: `
        <p>Pendant une simulation, cliquez sur le boutton <b>Favoris</b> en dessous de la question.</p>
    `
},
{
    id: 12,
    question: "Où retrouver mes questions favorites ?",
    answer: `
        <p>Cliquez sur le bouton <b>'Favoris'</b> en haut du tableau dans simulateur pour voir toutes vos questions favorites.</p>
    `
},
{
    id: 13,
    question: "Comment accéder au programme Mindset ?",
    answer: `
        <p>Cliquez sur le bouton <b>'Mindset QCM'</b> en haut du tableau. Le système vous propose les QCM du jour.</p>
    `
},
{
    id: 14,
    question: "Pourquoi mon examen ne démarre-t-il pas ?",
    answer: `
        <p>Vérifiez que vous avez sélectionné une option de pause et que la date/heure de l'examen n'est pas dépassée.</p>
    `
},
{
    id: 15,
    question: "Comment savoir si ma demande d'examen a été validée ?",
    answer: `
        <p>Le statut <b>'En cours de validation'</b> indique une attente. Une fois validé, le statut passe à <b>'Approuvé'</b>.</p>
    `
},
{
    id: 16,
    question: "Que faire en cas de problème technique lors d'un examen?",
    answer: `
        <p>Commencez par <b>vérifier votre connexion internet</b> pour vous assurer qu'elle est stable.</p>
        <p>Si la connexion est correcte, vous pouvez <b>fermer puis rouvrir votre navigateur</b>, puis reprendre l'examen via <em>"Continuer"</em> dans l'historique.</p>
        <p>Si le problème persiste, veuillez <b>contacter le service client</b> pour obtenir de l'assistance.</p>
    `
},
{
    id: 17,
    question: "Comment filtrer l'historique ?",
    answer: `
        <p>Utilisez la barre de recherche en haut du tableau avec un mot-clé (date, type, langue, statut...).</p>
    `
},
{
    id: 18,
    question: "Comment modifier l'affichage des colonnes dans simulateur ?",
    answer: `
        <p>Cliquez sur <b>'Visibilité'</b> et cochez/décochez les colonnes à afficher/cacher.</p>
    `
}
];

    const filteredFaqData = faqData.filter(q =>
        q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        q.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleQuestion = (questionId) => {
        setOpenQuestion(openQuestion === questionId ? null : questionId);
    };

    const clearSearch = () => setSearchTerm('');

    useEffect(() => {
        if (user_id) document.title = "eTrainApp | FAQ";
    }, [user_id]);

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState([]);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');
        if (groupeStored && accesGroupeStored) {
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim()) : []
                        ).flat();
                        setAccesGroupe(cleanedAccessArray);
                    }
                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) verifGroupe();
    }, [user_id]);

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading py-3">
                        <div className="col-lg-12 d-flex justify-content-between align-items-center">
                            <h2 className="m-0">
                                <FaQuestionCircle className="mr-2 text-success" />
                                FAQ
                            </h2>
                            <small className="text-muted">
                                <Link to="/Historique-complet" className="text-muted">Simulateur</Link> / FAQ
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        {/* Barre de recherche */}
                                        <div className="row mb-4">
                                            <div className="col-md-6 offset-md-3">
                                                <div className="input-group">
                                                    <span className="input-group-text bg-white border-end-0">
                                                        <FaSearch className="text-muted" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control border-start-0 ps-0"
                                                        placeholder="Rechercher une question..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                    {searchTerm && (
                                                        <button className="btn btn-link text-muted" onClick={clearSearch}>
                                                            <FaTimes />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Liste des questions */}
                                        <div className="faq-list">
                                            {filteredFaqData.map((q) => (
                                                <div key={q.id} className="mb-2">
                                                    <button
                                                        className="btn btn-light w-100 text-start d-flex justify-content-between align-items-center p-3 border-0"
                                                        onClick={() => toggleQuestion(q.id)}
                                                        style={{ borderRadius: '8px', transition: 'all 0.2s' }}
                                                    >
                                                        <span className="text-dark" style={{ fontSize: '14px', fontWeight: '500' }}>
                                                            {q.question}
                                                        </span>
                                                        {openQuestion === q.id ? (
                                                            <FaChevronUp className="text-muted" size={12} />
                                                        ) : (
                                                            <FaChevronDown className="text-muted" size={12} />
                                                        )}
                                                    </button>

                                                    {openQuestion === q.id && (
                                                        <div
                                                            className="p-3 mt-1 bg-light rounded"
                                                            style={{ fontSize: '13px', color: '#6c757d', lineHeight: '1.5' }}
                                                            dangerouslySetInnerHTML={{ __html: q.answer }}
                                                        />
                                                    )}
                                                </div>
                                            ))}

                                            {filteredFaqData.length === 0 && (
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <h5 className="text-muted">Aucun résultat trouvé</h5>
                                                    <button className="btn btn-link text-success mt-2" onClick={clearSearch}>
                                                        Effacer la recherche
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {/* Contact Support */}
                                        <div className="row mt-5 pt-3 border-top">
                                            <div className="col text-center">
                                                <p className="text-muted mb-3">Vous n'avez pas trouvé votre réponse ?</p>
                                                <div className="d-flex justify-content-center gap-3">
                                                    <a href="mailto:info@inovact.com" className="text-success text-decoration-none">
                                                        <FaEnvelope className="me-1" /> info@inovact.com
                                                    </a>
                                                    <span className="text-muted">|</span>
                                                    <a href="tel:+2290158585050" className="text-success text-decoration-none">
                                                        <FaPhone className="me-1" /> (+229) 0158585050
                                                    </a>
                                                    <span className="text-muted">|</span>
                                                    <a href="https://wa.me/22871647777" className="text-success text-decoration-none" target="_blank" rel="noreferrer">
                                                        <FaPhone className="me-1" /> (+228) 71647777
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;